import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const Loading = ({ message = "Seite wird geladen." }: { message?: string }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      minHeight: "32vh",
      display: "grid",
      placeItems: "center",
      px: 2,
      textAlign: "center"
    }}
  >
    <Box sx={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 1.25 }}>
      <CircularProgress size={26} thickness={4} color="primary" />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  </Box>
);

export default Loading;
